<template>
  <Popup :width="width" :closePopupEvent="closePopupCB">
    <div slot="header">
      <h6 class="login-header">Change Password</h6>
    </div>
    <div class="session-exp-popup">
      <FormError v-show="formError" :message="formError"></FormError>
      <!-- Form -->
      <div class="login-form">
        <form @submit.prevent="updatePasswordCB" autocomplete="off">
          <input autocomplete="false" name="hidden" type="text" style="display:none;" />

          <div class="vlt-lgn-form">
            <!-- Password Input -->
            <div class="vlt-input-group input-ico">
              <label class="login-label">Old Password</label>
              <div class="vlt-input">
                <input
                  id="oldpassword"
                  type="password"
                  aria-label="password"
                  v-model="oldpassword"
                  placeholder
                  maxlength="16"
                  autocomplete="off"
                />
                <p class="login-error-message">{{ oldpasswordError }}</p>
                <span class="ico-img">
                  <img :src="iconEyeOpenPath" @click="toggleInputMode" alt="eye img" />
                </span>
              </div>
            </div>

            <!-- Password Input -->
            <div class="vlt-input-group input-ico">
              <label class="login-label">New Password</label>
              <div class="vlt-input">
                <input
                  id="newpassword"
                  type="password"
                  aria-label="password"
                  v-model="newpassword"
                  placeholder
                  maxlength="16"
                  autocomplete="off"
                />
                <p class="login-error-message">{{ newpasswordError }}</p>
                <span class="ico-img">
                  <img :src="iconEyeOpenPath" @click="toggleInputMode" alt="eye img" />
                </span>
              </div>
            </div>

            <!-- Password Input -->
            <div class="vlt-input-group input-ico">
              <label class="login-label">Confirm Password</label>
              <div class="vlt-input">
                <input
                  id="retypepassword"
                  type="password"
                  aria-label="password"
                  v-model="retypepassword"
                  placeholder
                  maxlength="16"
                  autocomplete="off"
                />
                <p class="login-error-message">{{ retypepasswordError }}</p>
                <span class="ico-img">
                  <img :src="iconEyeOpenPath" @click="toggleInputMode" alt="eye img" />
                </span>
              </div>
            </div>

            <!-- Buttons -->
            <div class="vlt-lgn-btns" style="margin-top:10%;">
              <button
                type="submit"
                class="btn-lg-primary"
                ref="loginBtnSubmit"
                aria-label="Update button"
              >Update</button>
            </div>
          </div>
        </form>
      </div>
      <Loading v-show="showLoading"></Loading>
    </div>
  </Popup>
</template>

<script>
import Utility from "@/mixins/Utility";
import { EventBus } from "@/main";
import { mapActions, mapGetters } from "vuex";
import SimpleCrypto from "simple-crypto-js";

export default {
  name: "LoginForm",
  data() {
    return {
      width: "35%",
      oldpassword: null,
      newpassword: null,
      retypepassword: null,
      iconEyeOpenPath: require("@/assets/icons/eye.svg"),
      iconEyeClosePath: require("@/assets/icons/eye-close.svg"),
      showLoading: false,
      formError: null,
      //
      newpasswordError: "",
      oldpasswordError: "",
      retypepasswordError: "",
      minChar: 8,
      maxChar: 16
    };
  },
  props: ["closePopupCB"],
  components: {
    Popup: () => import("@/components/Slots/Popup.vue"),
    Loading: () => import("@/components/Templates/Loading.vue"),
    FormError: () => import("@/components/Templates/FormError.vue")
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["AppUser", "SECRET_KEY"])
  },
  watch: {
    formError(value) {
      if (value) {
        setTimeout(() => {
          this.formError = null;
        }, 5000);
      }
    }
  },
  methods: {
    ...mapActions(["actUpdateSubscriber"]),
    closePopup() {
      // Hide the popup
      this.closePopupCB();
    },
    updatePasswordCB() {
      if (!this.isFormValid()) return;

      // Show the loader
      this.showLoading = true;
      // Define the data to be sent
      let data = {
        password: this.newpassword
      };

      this.$refs.loginBtnSubmit.disabled = true;

      this.actUpdateSubscriber(data)
        .then(response => {

          if (response.error) {
            this.formError = response.reason;
          } else {
            if (localStorage.getItem("LoginType")) {
              let LoginType = JSON.parse(localStorage.getItem("LoginType"));
              if (LoginType.type == "EMAIL") {
                let simpleCrypto = new SimpleCrypto(this.SECRET_KEY);
                LoginType.password = simpleCrypto.encrypt(this.newpassword);
                // save back to storage
                localStorage.setItem("LoginType", JSON.stringify(LoginType));
              }
            }
            this.closePopupCB();
            this.$refs.loginBtnSubmit.disabled = false;
          }
        })
        .catch(error => {
          this.$refs.loginBtnSubmit.disabled = false;
          // console.log('[Subscribe updatePasswordCB error]', error);
        });
    },
    isFormValid() {
      return (
        this.isOldPasswordValid() &&
        this.isNewPasswordValid() &&
        this.isRetypePasswordValid()
      );
    },
    isOldPasswordValid() {
      let passwordIncorrect = false;
      let LoginType = JSON.parse(localStorage.getItem("LoginType"));
      if (LoginType.type == "EMAIL") {
        let simpleCrypto = new SimpleCrypto(this.SECRET_KEY);
        let password = simpleCrypto.decrypt(LoginType.password);
        if (this.oldpassword !== password) {
          passwordIncorrect = true;
        }
      }
      if (!this.oldpassword) {
        this.oldpasswordError = "Please Enter old password";
        document.getElementById("oldpassword").classList.add("formError");
        return false;
      } else if (this.oldpassword.length < this.minChar) {
        this.oldpasswordError =
          "Old Password must contain altleast 6 characters";
        document.getElementById("oldpassword").classList.add("formError");
        return false;
      } else if (passwordIncorrect) {
        this.oldpasswordError = "Old Password incorrect";
        document.getElementById("oldpassword").classList.add("formError");
        return false;
      } else {
        this.oldpasswordError = "";
        document.getElementById("oldpassword").classList.remove("formError");
        return true;
      }
    },
    isNewPasswordValid() {
      if (!this.newpassword) {
        this.newpasswordError = "Please Enter new password";
        document.getElementById("newpassword").classList.add("formError");
        return false;
      } else if (this.newpassword.length < this.minChar) {
        this.newpasswordError =
          "New Password must contain altleast 6 characters";
        document.getElementById("newpassword").classList.add("formError");
        return false;
      } else if (this.oldpassword === this.newpassword) {
        this.newpasswordError =
          "New password must not be same as old password.";
        document.getElementById("newpassword").classList.add("formError");
        return false;
      }
      // else if (!this.validateInputPassword(this.newpassword)) {
      //   this.newpasswordError = `Password should contain atleast One special charcter, One upper case and One number.`;
      //   document.getElementById('newpassword').classList.add('formError');
      //   return false;
      // }
      else {
        this.newpasswordError = "";
        document.getElementById("newpassword").classList.remove("formError");
        return true;
      }
    },
    isRetypePasswordValid() {
      if (!this.retypepassword) {
        this.retypepasswordError = "Please Enter Confirm password";
        document.getElementById("retypepassword").classList.add("formError");
        return false;
      } else if (this.retypepassword.length < this.minChar) {
        this.retypepasswordError =
          "Confirm Password must contain altleast 6 characters";
        document.getElementById("retypepassword").classList.add("formError");
        return false;
      } else if (this.oldpassword === this.retypepassword) {
        this.retypepasswordError =
          "New password must not be same as old password.";
        document.getElementById("retypepassword").classList.add("formError");
        return false;
      } else if (this.retypepassword !== this.newpassword) {
        this.retypepasswordError = "Passwords not matching";
        document.getElementById("retypepassword").classList.add("formError");
        return false;
      }
      // else if (!this.validateInputPassword(this.retypepassword)) {
      //   this.retypepasswordError = `Password should contain atleast One special charcter, One upper case and One number.`;
      //   document.getElementById('retypepassword').classList.add('formError');
      //   return false;
      // }
      else {
        this.retypepasswordError = "";
        document.getElementById("retypepassword").classList.remove("formError");
        return true;
      }
    },
    toggleInputMode(_event) {
      // Get the target element
      let target = _event.target;
      // Get the container div of the input field
      let parentNode = target.parentNode.parentNode;
      // Get the input element from it
      let inputElm = parentNode.getElementsByTagName("input")[0];
      // Now change the type to text if password or vice-versa and change the icon
      if (inputElm.type === "password") {
        inputElm.type = "text";
        // Change the icon
        target.src = this.iconEyeClosePath;
      } else {
        inputElm.type = "password";
        // Change the icon
        target.src = this.iconEyeOpenPath;
      }
    }
  },
  mixins: [Utility]
};
</script>

<style lang="scss" scoped>
@import "~sass/modules/variables";
input {
  caret-color: #4558dd;
  width: 2px;
}
.session-exp-popup {
  padding: 20px;
}
.login-logo {
  text-align: center;
  img {
    width: 30%;
    margin: 2% 0;
  }
}
.vlt-signup-divd {
  p {
    display: block;
    margin: 15px 0;
    color: $font-clr-black;
    font-weight: 550;
    font-size: 15px;
    text-align: center;
    font-family: "ProximanovaBold";
  }
  .orline {
    border-bottom: 1px solid #dcdcdc;
    margin-top: 5%;
  }
}
.social-logo {
  margin: 0 10% 0 10%;
  display: flex;
  // text-align: center;
  div {
    flex: 1;
    div {
      cursor: pointer;
      img {
        margin: 10px;
        width: 15%;
        float: left;
      }
      p {
        float: left;
        margin-top: 7px;
      }
    }
  }
}
.social-fb {
  div {
    background: #3b5998;
    border-radius: 2px;
    p {
      color: #ffffff;
      font-size: 20px;
      font-weight: bold;
    }
  }
}
.social-google {
  div {
    border: 2px solid rgb(239, 236, 236);
    border-radius: 2px;
    background: rgb(239, 236, 236);
    p {
      color: #000000;
      font-size: 20px;
      font-family: "ProximanovaSemibold";
    }
  }
}
.login-form {
  margin: 0 10% 0 10%;
}
.vlt-input-group {
  margin: 0 0 10px 0;
}
.vlt-lgn-fgtpwd {
  color: #212121;
  font-family: "ProximanovaBold";
  margin-bottom: 15px;
}
.vlt-signup {
  padding: 20px;

  :nth-child(1) {
    margin-left: 25%;
  }
  :nth-child(2) {
    margin-left: 10px;
    cursor: pointer;
    font-weight: 600;
  }
  p {
    color: $font-clr-black;
    float: left;
  }
}
.login-header {
  color: #212121;
  font-family: "ProximanovaBold";
  font-size: 30px;
  // line-height: 37px;
}
.login-with {
  color: #212121;
  font-family: "ProximanovaBold";
  font-size: 14px;
  text-align: justify;
  margin: 2% 0;
}
.or {
  color: #212121;
  font-family: "ProximanovaRegular";
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  text-align: justify;
}
.login-label {
  color: #212121;
  font-family: "ProximanovaBold";
  font-size: 18px;
  line-height: 22px;
}
.login-error-message {
  color: #d0021b;
  font-family: "ProximanovaRegular";
  font-size: 16px;
  font-weight: 100;
  line-height: 18px;
  margin-top: 5px;
}
.new-user {
  color: #212121;
  font-family: "ProximanovaRegular";
  font-size: 16px;
  line-height: 18px;
}
.signup {
  color: #4558dd !important;
  font-family: "ProximanovaBold";
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .session-exp-popup {
    padding: 10px;
  }
  .vlt-input-group {
    margin: 0 0 5px 0;
    label {
      font-size: 14px;
    }
  }
  .login-header {
    font-size: 20px;
  }
  .vlt-signup-divd {
    p {
      margin: 7px 0;
      font-size: 16px;
    }
  }
  input[type="email"],
  input[type="password"],
  input[type="text"] {
    height: 30px;
  }
  .vlt-lgn-fgtpwd {
    margin-bottom: 8px;
    font-size: 12px;
  }
  button {
    padding: 8px;
    font-size: 15px;
  }
  .vlt-signup {
    padding: 10px;

    :nth-child(1) {
      margin-left: 25%;
    }
    :nth-child(2) {
      margin-left: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Popups/ChangePassword.vue